export class GameServiceError extends Error {
  constructor(
    readonly code:
      | "NETWORK"
      | "SESSION_OPEN"
      | "INSUFFICIENT_FUNDS"
      | "SEASON_INACTIVE"
      | "ENERGY_FULL"
      | "REFILL_LIMIT"
      | "ARENA_SYNC"
      | "INVALID_ACTION",
    message: string,
    readonly details: Record<string, string> = {},
  ) {
    super(message);
    this.name = "GameServiceError";
  }
}

export function isGameServiceError(error: unknown): error is GameServiceError {
  return error instanceof GameServiceError;
}
